
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import SettingsModel from "slotworks/model/settings/settings-model";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";
import StateMachine from "slotworks/state-machine/state-machine";

export default class DisabledSkipButtonBehaviour extends AbstractButtonBehaviour {

    public init() {
        Layers.SmartButton.setScene("skip").execute();
        this.button = Layers.SmartButton.getFlexiButton("next");
        this.button.setEnabled(false);
        
        const autoButton = Layers.SmartButton.getFlexiButton("auto_start_disabled");
        if (autoButton) {
            autoButton.setEnabled(false);
        }
    }

    public destroy() {
        super.destroy();
    }
}
